module.exports = __webpack_public_path__ + "img/noun_location pin_4382115.082f83ec.svg";